/*
 * Converts an ingredient title (or an already `| handle`-filtered string)
 * into the slug used by /pages/ingredient/{handle}.
 *
 * Shopify's `| handle` filter gets most ingredient names right, but doesn't
 * insert a hyphen at a letter/digit boundary (e.g. an ingredient named
 * "5-HTP" needs "5-htp", not "5htp"), so this corrects that and lowercases/
 * dashes spaces. That final step is a no-op on input that's already been
 * through `| handle`, so this is safe to call on either raw titles or
 * pre-handled strings.
 *
 * A couple of ingredient names don't fit the pattern above and need
 * hardcoded overrides to match their actual /pages/ingredient/ handle.
 */
function getIngredientPageHandle(rawHandle) {
  let handle = rawHandle
    .replace(/([a-zA-Z])(?=\d)/g, "$1-")
    .replace(/(\d)(?=[a-zA-Z])/g, "$1-")
    .replace(/®/g, "")
    .toLowerCase()
    .replace(/ /g, "-");

  if (handle === "thymoquin") {
    handle = "thymo-quin";
  }
  if (handle === "acetyl-l-carnitine-hcl") {
    handle = "acetyl-l-carnitine-h-cl";
  }

  return handle;
}
